import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition } from "@mcurros2/microm";

const columns = () =>
(
    {
        c_solicitudruteo_id: new EntityColumn<string>({ name: 'c_solicitudruteo_id', type: 'char', length: 20, flags: c.PKAutonum, prompt: 'Solicitud Id' }),
        c_fileprocess_id: new EntityColumn<string>({ name: 'c_fileprocess_id', type: 'char', length: 20, flags: c.FK, prompt: 'Fileprocess Id' }),
        c_file_id: new EntityColumn<string>({ name: 'c_file_id', type: 'char', length: 20, flags: c.FK, prompt: 'File Id' }),
        vc_filepath: new EntityColumn<string>({ name: 'vc_filepath', type: 'varchar', length: 2048, flags: EntityColumnFlags.None, prompt: 'Filepath' }),
        c_proceso_id: new EntityColumn<string>({ name: 'c_proceso_id', type: 'char', length: 20, flags: c.FK, prompt: 'Proceso Id' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {

    }
)

const lookups = () =>
(
    {

    }
)

const procs = () =>
(
    {

    }
)

const clientActions = () =>
(
    {

    }
)

export class SolicitudesRuteoImportacionDef extends EntityDefinition {

    columns = columns();
    views = views();
    lookups = lookups();
    procs = procs();
    clientActions = clientActions();

    constructor() {
        super('SolicitudesRuteoImportacion');
    }
}